<template>
  <el-dialog
    title="发布挂牌"
    :visible.sync="issueTradeVisible"
    width="600px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form label-width="100px">
      <el-form-item
        label="报价类型"
        required
      >
        {{ detailData.priceType | keyFilter('myStore','priceType') }}
      </el-form-item>
      <el-form-item
        label="挂牌库存"
        required
      >
        <el-input
          v-model.trim="detailData.totalQuantity"
          class="w220"
          maxlength="32"
        />
        {{ detailData.unitName }}
      </el-form-item>
      <!-- <el-form-item label="价格" v-if="detailData.priceType==='DX'" required>
        <el-input-number class="w220" v-model.trim="detailData.priceList[0].unitPrice" :controls="false" :min="0"/>
      </el-form-item> -->
    </el-form>
    <div class="m-t-30 m-b-10 text-c">
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确认
      </el-button>
      <el-button @click="handleClose">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
export default {
  name: 'IssueTrade',
  components: {
  },
  props: {
    issueTradeVisible: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => { return { priceList: [] } }
    },
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    toSubmit () {
      const regInt = /^[0-9]*[1-9][0-9]*$/

      if (!this.detailData.totalQuantity || !regInt.test(Number(this.detailData.totalQuantity))) {
        this.$message.warning('挂牌库存必须为大于0的整数')
        return
      }
      const param = {
        quotationId: this.detailData.id,
        totalQuantity: this.detailData.totalQuantity,
        priceList: this.detailData.priceList,
      }
      // 区分调整库存和发布挂牌
      api.myStore.createTrade(param).then(res => {
        this.$message.success('操作成功')
        this.handleClose()
      })
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.warehouse {
  max-height: 500px;
  overflow-y: auto;
}
</style>
